import {
  OVERLAY_ADD_OVERLAY,
  OVERLAY_CLOSE_OVERLAY,
  OVERLAY_REMOVE_OVERLAY,
  OVERLAY_UPDATE_OVERLAY,
} from '../constants';

const DEFAULT_STATE = {
  activeOverlays: [],
};

export const overlay = (state = DEFAULT_STATE, action) => {
  let activeOverlays = Object.assign([], state.activeOverlays);
  switch (action.type) {
    case OVERLAY_ADD_OVERLAY:
      if (
        activeOverlays.findIndex(
          (o) => o.name == action.payload.componentName
        ) == -1
      ) {
        activeOverlays.push({
          name: action.payload.componentName,
          onOverlayClick: action.payload.onOverlayClick,
        });
      }

      return {
        ...state,
        activeOverlays,
      };

    case OVERLAY_UPDATE_OVERLAY:
      const overlayIndex = activeOverlays.findIndex(
        (o) => o.name == action.payload.componentName
      );
      if (overlayIndex != -1) {
        activeOverlays[overlayIndex].name = action.payload.componentName;
        activeOverlays[overlayIndex].onOverlayClick =
          action.payload.onOverlayClick;
      }

      return {
        ...state,
        activeOverlays,
      };

    case OVERLAY_REMOVE_OVERLAY:
      let index = activeOverlays.findIndex(
        (c) => c.name == action.payload.componentName
      );
      if (index != -1) {
        activeOverlays.splice(index, 1);
      }

      return {
        ...state,
        activeOverlays,
      };

    case OVERLAY_CLOSE_OVERLAY:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};
